var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSmallTrash = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-5748.378-307a2.379,2.379,0,0,1-2.375-2.376V-319.81h-.8a.442.442,0,0,1-.445-.443.443.443,0,0,1,.445-.445h3.329v-.543a1.762,1.762,0,0,1,1.759-1.76h3.165a1.762,1.762,0,0,1,1.76,1.76v.543h3.329a.443.443,0,0,1,.445.445.442.442,0,0,1-.445.443h-.8v10.434a2.38,2.38,0,0,1-2.376,2.376Zm-1.487-2.376a1.489,1.489,0,0,0,1.487,1.487h6.987a1.488,1.488,0,0,0,1.487-1.487h0V-319.81h-9.963Zm2.526-11.865v.543h4.908v-.543a.873.873,0,0,0-.872-.872h-3.165A.873.873,0,0,0-5747.339-321.24Zm2.011,11.313v-7.846a.442.442,0,0,1,.443-.445.443.443,0,0,1,.444.445v7.849a.442.442,0,0,1-.444.443A.444.444,0,0,1-5745.328-309.927Zm2.9-.488v-6.871a.443.443,0,0,1,.444-.445.443.443,0,0,1,.443.445v6.871a.443.443,0,0,1-.443.445A.443.443,0,0,1-5742.431-310.415Zm-5.8,0v-6.871a.442.442,0,0,1,.443-.445.443.443,0,0,1,.445.445v6.871a.443.443,0,0,1-.445.445A.444.444,0,0,1-5748.227-310.415Z",
  transform: "translate(5757.985 327)"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSmallTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/small-trash.226aefdd.svg";
export { ForwardRef as ReactComponent };